import React from 'react';

import UpdateDate from '../UpdateDate';

export default function Chip() {
  return (
    <div className='bso-chip'>
      <UpdateDate />
    </div>
  );
}
